
<div>
    <div class="card bg-dark text-white">
      <img class="card-img" loading="lazy" src="./assets/backgroundImg/threatbackgroundImg.jpg" alt="Card image">
      <div class="card-img-overlay" >
        <div class="bg-text" >
          <h2 class="contextMessage">Understanding the Threat of Substitutes</h2>

          <p style="text-align: start;
          display: flex;
          justify-content: start;
          width: 100%;
          margin-bottom: 0px;"
          >Follow these steps:</p>
          <ul class="breadcrumb">
            <li>Select country</li>
            <li>India</li>
            <li>Select Platform</li>
            <li>Amazon</li>
            <li>Select Service</li>
            <li>Competitor Analsysis</li>
          </ul>
  
          <p>Stay ahead of market challenges with our "Threat of Substitutes" analysis. 
             This module provides a deep dive into potential alternatives to your products, helping you assess the risks posed by substitute goods and services. 
             By identifying emerging competitors and understanding customer preferences, you'll be better equipped to innovate and differentiate your offerings, ensuring your market position remains strong and resilient.
          </p>
        </div>

        
  
      </div>
  
    </div>
    
  </div>